export function digits(value) {
  return {
    valid: !value || value.match(/^[0-9]*$/),
    errorMessage: 'Bitte geben Sie nur Zahlen ein.',
  }
}
